/* eslint-disable @typescript-eslint/no-empty-function */
import Bole from '@haptik/helpers/build/esm/bole';

import {
  UPDATE_SEND_INVITE_EMAIL,
  SEND_INVITE_LOADING,
  SEND_INVITE_SUCCESS,
  SEND_INVITE_ERROR,
  SEND_INVITE_CLEAR_MESSAGE,
  SET_TIMEOUT_ID,
  SET_IS_EXPANDED,
} from './actionTypes';

import { ERROR_MESSAGE_FETCH } from '../const';

import { inviteYourFriendRequest } from './apis';
import { validateEmail } from '../utils';

const clearInviteMessage = (timeoutId) => (dispatch) => {
  if (timeoutId) clearTimeout(timeoutId);
  const newTimeoutId = setTimeout(() => {
    dispatch({ type: SEND_INVITE_CLEAR_MESSAGE });
  }, 6000);
  dispatch({ type: SET_TIMEOUT_ID, payload: { timeoutId: newTimeoutId } });
};

export const inviteYourFriend = (botId) => {
  return async (dispatch, state) => {
    try {
      const { email, timeoutId } = state;
      dispatch({ type: SEND_INVITE_LOADING });
      const response = await inviteYourFriendRequest(email, botId);
      if (response.success) {
        dispatch({ type: SEND_INVITE_SUCCESS });
      } else {
        dispatch({
          type: SEND_INVITE_ERROR,
          payload: { error: response.response.error },
        });
      }
      // clear success/error message after 6s
      clearInviteMessage(timeoutId)(dispatch);
    } catch (error) {
      Bole.alert(ERROR_MESSAGE_FETCH);
    }
  };
};

export const updateInviteEmail = (email) => {
  return (dispatch) => {
    dispatch({
      type: UPDATE_SEND_INVITE_EMAIL,
      payload: { email, disabled: !validateEmail(email) },
    });
  };
};

export const toogleIsExapnded = () => {
  return (dispatch) => {
    dispatch({ type: SET_IS_EXPANDED });
  };
};
